import { NavigateService } from './../../../core/services/navigate.service';
import { AlertDialogComponent } from './../../../store/dialogs/alert-dialog/alert-dialog.component';
import { Component, Input, OnInit } from '@angular/core';
import { CmsService } from './../../../core/services/cms.service';
import { LoadingService } from './../../../core/services/loading.service';
import { CustomerService } from './../../../core/services/customer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { MessageService } from 'src/app/core/services/message.service';
import { IndustryDescription, IndustryProductID } from 'src/app/model/industry';
import { OptionInfo } from 'src/app/model/feature';
import { AppComponent } from 'src/app/app/app.component';
import { MatDialog } from '@angular/material/dialog';
import { LoginService } from 'src/app/core/services/login.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { OperationResult, TbAuthService } from '@tb/auth';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { PdfCreatorIndustriesCompareService } from 'src/app/core/services/pdfcreator-industries-compare.service';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { MagoWebService } from 'src/app/core/services/mago-web.service';
import { StoreRolesService } from 'src/app/core/services/store-role.service';
import { ProductService } from 'src/app/core/services/product.service';
import { Mode } from 'src/app/model/subscription';
import { CountryService } from 'src/app/core/services/country.service';
import { MagoCloudService } from 'src/app/core/services/mago-cloud.service';

@Component({
    selector: 'ms-industries-list',
    templateUrl: './industries-list.component.html',
    styleUrls: ['./industries-list.component.scss'],
})
export class IndustriesListComponent implements OnInit {
    private isAmazonDsp = false;
    public showCart = false;
    public loading: boolean = true;
    public showMessage: boolean = false;
    public industryDictionaryList: IndustryDescription[] = []; //usato nell'html
    public currency = '';
    public title: string;
    public subtitle: string;
    public site_footer: string;
    public language: string;
    private subscriptionNfs: string;
    public priceVisible: boolean = false;
    // translate dialog variables
    shoppingCompactList: string;
    authorizationStored;
    authorizationProperties: AuthorizationProperties;
    @Input() productID: string;
    @Input() edition: string;

    constructor(
        public customerService: CustomerService,
        private configurationService: ConfigurationService,
        private messageService: MessageService,
        private router: Router,
        public loadingService: LoadingService,
        private appComponent: AppComponent,
        private dialog: MatDialog,
        public loginService: LoginService,
        private pdfCreatorIndustriesCompareService: PdfCreatorIndustriesCompareService,
        public cmsService: CmsService,
        public workFlow: WorkFlowService,
        public authService: TbAuthService,
        private variable: TranslatedVariables,
        public navigateService: NavigateService,
        private activatedRoute: ActivatedRoute,
        private magoWebService: MagoWebService,
        public storeRoleService: StoreRolesService,
        private productService: ProductService,
        private countryService: CountryService,
        private magoCloudService: MagoCloudService
    ) {
        this.productService.productRelease = '';
        this.messageService.setMessage(this.variable.messageLoadingsDetails, '');
    }

    ngOnInit() {
        this.activatedRoute.queryParams.subscribe((params) => {
            if (!params) return;
            this.subscriptionNfs = params.subscriptionNfs;
            if (params.isAmazonDsp) {
                this.isAmazonDsp = params.isAmazonDsp == 'true';
            }
        });

        switch (this.productID) {
            case IndustryProductID.MW:
                this.getMagoWebIndustries();
                break;
            default:
                this.getIndustries();
                break;
        }
    }

    async getMagoWebIndustries() {
        this.loadingService.setLoading(true);
        try {
            this.language = this.workFlow.getLanguageForCms();
            this.magoWebService.Clear();
            let result: OperationResult = await this.configurationService.getmagowebindustries(this.language, 'PRO');
            if (!result.Result) {
                this.industryDictionaryList = [];
                this.loadingService.setLoading(false);
                this.workFlow.showMessage(this.variable.popupTitle, this.variable.messageSubTitle_2);
                return;
            }
            let data: IndustryDescription[] = result.Content as IndustryDescription[];
            this.loadingService.setLoading(false);
            if (data === null || data === undefined) {
                this.workFlow.showMessage(this.variable.messageTitle_1, this.variable.messageSubTitle_1);
                return;
            }
            this.industryDictionaryList = data;
            this.showCart = this.industryDictionaryList.length != 0;
            if (this.industryDictionaryList.length == 0) {
                this.workFlow.showMessage(this.variable.popupTitle, this.variable.messageSubTitle_2);
            }
        } catch (err) {
            this.loading = false;
            this.loadingService.setLoading(this.loading);
            const dlgAsk = this.dialog.open(AlertDialogComponent, {
                data: {
                    Title: this.variable.errorTitle,
                    Message: err.message,
                },
            });
            dlgAsk.afterClosed().subscribe((resAskDlg) => {
                if (resAskDlg === undefined) {
                    this.router.navigate(['home']);
                }
            });
            return;
        }
    }
    selectedFeaturesOptionInfo: OptionInfo[] = [];

    public LinkToDetail(editionCode: string, moduleCode: string, version: number) {
        this.router.navigate(['/store/ProductDetail', { editionCode: editionCode, moduleCode: moduleCode, version: version.toString() }]);
    }

    isAuthenticated(productID: string, moduleCode: string, version: number) {
        if (this.appComponent.isLogged) {
            if (productID == IndustryProductID.MW) {
                this.router.navigate(['/magoweb-management/magoweb-management'], {
                    queryParams: {
                        moduleCode: moduleCode,
                        version: version.toString(),
                        subscriptionNfs: this.subscriptionNfs,
                    },
                });
            } else if (productID == IndustryProductID.MC) {
                this.router.navigate(['/magocloud-management/magocloud-management'], {
                    queryParams: { moduleCode: btoa(moduleCode), version: btoa(version.toString()), productID: btoa(productID) },
                });
            }
        } else {
            this.router.navigate(['/create'], { queryParams: { moduleCode: moduleCode, version: version.toString() } });
        }
    }

    public async openPdfIndustry(tempIndustry: IndustryDescription) {
        this.loadingService.setLoading(true);
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
        //valorizzo la release di prodotto
        if (this.productService.resellerCode.length == 0) {
            this.productService.resellerCode = this.customerService.companyInfo.CompanyCode;
        }
        await this.productService.setProductRelease(
            tempIndustry.ProductID,
            Mode.rtm.toString(),
            this.countryService.countrySelected,
            '',
            tempIndustry.ModuleCode,
            this.storeRoleService.IsInternal ? '1' : '0',
            ''
        );
        let pdfDocGenerator = await this.pdfCreatorIndustriesCompareService.createPdfCompareIndustry(
            this.workFlow.getLanguageForCms(),
            tempIndustry.ModuleCode,
            this.authorizationProperties.accountName,
            this.productService.productRelease,
            tempIndustry.ProductID
        );
        await this.pdfCreatorIndustriesCompareService.openPdf(pdfDocGenerator);
        this.loadingService.setLoading(false);
    }
    async getIndustries() {
        this.loadingService.setLoading(true);
        try {
            this.language = this.workFlow.getLanguageForCms();
            this.magoCloudService.Clear();
            let result: OperationResult = await this.configurationService.getallstdeditionindustries(this.language);
            if (!result.Result) {
                this.industryDictionaryList = [];
                this.loadingService.setLoading(false);
                this.workFlow.showMessage(this.variable.popupTitle, this.variable.messageSubTitle_2);
                return;
            }
            let data: IndustryDescription[] = result.Content as IndustryDescription[];
            this.loadingService.setLoading(false);
            if (data === null || data === undefined) {
                this.workFlow.showMessage(this.variable.messageTitle_1, this.variable.messageSubTitle_1);
                return;
            }
            this.industryDictionaryList = data;
            this.showCart = this.industryDictionaryList.length != 0;
            if (this.industryDictionaryList.length == 0) {
                this.workFlow.showMessage(this.variable.popupTitle, this.variable.messageSubTitle_2);
            }
        } catch (err) {
            this.loading = false;
            this.loadingService.setLoading(this.loading);
            const dlgAsk = this.dialog.open(AlertDialogComponent, {
                data: {
                    Title: this.variable.errorTitle,
                    Message: err.message,
                },
            });
            dlgAsk.afterClosed().subscribe((resAskDlg) => {
                if (resAskDlg === undefined) {
                    this.router.navigate(['home']);
                }
            });
            return;
        }
    }
}
